import { Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { FunctionComponent } from 'react';
import { reduceResolution, wbp } from 'Theme';
import { useCommonStyles } from './CommonStyles';
import HeaderCell from './HeaderCell';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            borderBottom: '2px solid #DDDDDD',
            paddingLeft: '0px',
            paddingRight: '0px',
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            },
            [theme.breakpoints.up('md')]: {
                paddingTop: '15px',
                paddingBottom: '15px'
            }
        },
        text: {
            fontFamily: 'Poppins',
            fontWeight: 500,
            color: '#7A7A7A',
            [theme.breakpoints.down(wbp)]: {
                fontSize: `${reduceResolution(14)}px`,
                lineHeight: `${reduceResolution(18)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                fontSize: '14px',
                lineHeight: '18px'
            }
        }
    })
);

const TableHeaderDetail: FunctionComponent = () => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();

    return (
        <Grid
            container
            className={clsx(classes.container, commonClasses.rowContainer)}
        >
            <HeaderCell
                xl={7}
                lg={7}
                xs={3}
                title="Item"
                className={clsx(commonClasses.desktop, commonClasses.bigWidthCell)}
                labelClassName={classes.text}
            />
            <HeaderCell
                xs={1}
                xl={1}
                title="Qty"
                className={clsx(commonClasses.cellRight, commonClasses.smallWidthCellDetail)}
                labelClassName={classes.text}
            />
            <HeaderCell
                xs={1}
                title="Price"
                className={clsx(commonClasses.cellRight, commonClasses.smallWidthCellDetail)}
                labelClassName={classes.text}
            />
            <HeaderCell
                xs={1}
                title="Total"
                className={clsx(commonClasses.cellRight, commonClasses.smallWidthCellDetail)}
                labelClassName={classes.text}
            />
            <HeaderCell
                xs={1}
                title=""
            />
        </Grid>
    );
};

export default TableHeaderDetail;
